// Níveis de log
const LOG_LEVELS = {
  ERROR: 'error',
  WARN: 'warn',
  INFO: 'info',
  DEBUG: 'debug'
};

// Configuração do ambiente
const isDevelopment = process.env.NODE_ENV === 'development';
const LOG_LEVEL = isDevelopment ? LOG_LEVELS.DEBUG : LOG_LEVELS.ERROR;

// Cache para evitar logs repetidos em curto período
const logCache = new Map();
const CACHE_TIMEOUT = 5000; // 5 segundos

// Função para limpar cache antigo
const cleanOldCache = () => {
  const now = Date.now();
  for (const [key, value] of logCache.entries()) {
    if (now - value.timestamp > CACHE_TIMEOUT) {
      logCache.delete(key);
    }
  }
};

// Função para gerar hash do log
const getLogHash = (message, data) => {
  return `${message}-${JSON.stringify(data)}`;
};

// Função principal de log
const log = (level, message, data = null) => {
  // Em produção, só loga erros
  if (!isDevelopment && level !== LOG_LEVELS.ERROR) {
    return;
  }

  // Limpa cache antigo
  cleanOldCache();

  // Gera hash do log
  const logHash = getLogHash(message, data);

  // Verifica se é um log repetido
  const cachedLog = logCache.get(logHash);
  if (cachedLog) {
    const timeSinceLastLog = Date.now() - cachedLog.timestamp;
    if (timeSinceLastLog < CACHE_TIMEOUT) {
      cachedLog.count++;
      return;
    }
  }

  // Prepara os dados do log
  const logData = data ? { ...data } : {};
  
  // Remove dados sensíveis
  if (logData.password) logData.password = '[REDACTED]';
  if (logData.token) logData.token = '[REDACTED]';
  
  // Formata a mensagem
  const formattedMessage = `[${new Date().toISOString()}] ${level.toUpperCase()}: ${message}`;
  
  // Executa o log apropriado
  switch (level) {
    case LOG_LEVELS.ERROR:
      console.error(formattedMessage, logData);
      break;
    case LOG_LEVELS.WARN:
      console.warn(formattedMessage, logData);
      break;
    case LOG_LEVELS.INFO:
      console.info(formattedMessage, logData);
      break;
    case LOG_LEVELS.DEBUG:
      console.debug(formattedMessage, logData);
      break;
    default:
      console.log(formattedMessage, logData);
  }

  // Atualiza o cache
  logCache.set(logHash, {
    timestamp: Date.now(),
    count: 1
  });
};

// Funções de conveniência
export const logError = (message, data = null) => log(LOG_LEVELS.ERROR, message, data);
export const logWarn = (message, data = null) => log(LOG_LEVELS.WARN, message, data);
export const logInfo = (message, data = null) => log(LOG_LEVELS.INFO, message, data);
export const logDebug = (message, data = null) => log(LOG_LEVELS.DEBUG, message, data);

// Função para obter estatísticas de log
export const getLogStats = () => {
  const stats = {
    totalCached: logCache.size,
    repeatedLogs: Array.from(logCache.entries())
      .filter(([_, value]) => value.count > 1)
      .map(([key, value]) => ({
        message: key,
        count: value.count,
        lastLogged: new Date(value.timestamp).toISOString()
      }))
  };
  return stats;
};